import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
import { SITE, NAV } from '../lib/site';
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b border-white/10 bg-jk-ink/90 backdrop-blur" data-id="element-66" data-mp="2nku1se9snriy">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6" data-id="element-67" data-mp="2rmxdn40dky4r">
        <Link to="/" className="flex-shrink-0" onClick={() => setOpen(false)} data-id="element-68" data-mp="2wkgri2t5v8w6">
          <img src={SITE.logo} alt="Junk Kings free estimates and service information" className="h-auto w-32 rounded sm:w-44" data-id="element-69" data-mp="31c8n4rr6c4t6" />
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" data-id="element-70" data-mp="3ba4r8zlp1zhs">
          {NAV.map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => `rounded-md px-3 py-2 font-display text-lg font-semibold uppercase tracking-wide transition-colors ${isActive ? 'text-jk-red' : 'text-white/80 hover:text-white'}`} data-id="element-71" data-mp="3fbq2yhmhs7qe">
              {item.label}
            </NavLink>)}
        </nav>

        <div className="flex items-center gap-2" data-id="element-72" data-mp="2hon6i5uk33wt">
          <a href={SITE.phoneHref} className="hidden items-center gap-2 rounded-md bg-jk-red px-4 py-2.5 font-display text-lg font-bold uppercase tracking-wide text-white transition-transform hover:scale-[1.03] hover:bg-jk-redDark sm:flex" data-id="element-73" data-mp="2hpy9w4k3a9ne">
            <PhoneIcon className="h-4 w-4" data-id="element-74" data-mp="35jpvqex9v9dt" />
            {SITE.phoneDisplay}
          </a>
          <button onClick={() => setOpen(v => !v)} className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-white/15 text-white lg:hidden" aria-label="Toggle menu" aria-expanded={open} data-id="element-75" data-mp="30lwodik8g9by">
            {open ? <XIcon className="h-6 w-6" data-id="element-76" data-mp="1rew5kbcyefnz" /> : <MenuIcon className="h-6 w-6" data-id="element-77" data-mp="1rfo1jnagqfes" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-78" data-mp="1wbuyiqkvsgkl">
        {open && <motion.nav initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden border-t border-white/10 bg-jk-ink lg:hidden" data-id="element-79" data-mp="1ho1lndn6js5p">
            <div className="flex flex-col px-4 py-3" data-id="element-80" data-mp="18p6e9y8egc0t">
              {NAV.map(item => <NavLink key={item.to} to={item.to} onClick={() => setOpen(false)} className={({
            isActive
          }) => `rounded-md px-3 py-3 font-display text-xl font-semibold uppercase tracking-wide ${isActive ? 'text-jk-red' : 'text-white/85'}`} data-id="element-81" data-mp="1cpzx4d6zj0mu">
                  {item.label}
                </NavLink>)}
              <a href={SITE.phoneHref} className="mt-2 flex items-center justify-center gap-2 rounded-md bg-jk-red px-4 py-3 font-display text-xl font-bold uppercase tracking-wide text-white" data-id="element-82" data-mp="mf68ejncwq2b">
                <PhoneIcon className="h-5 w-5" data-id="element-83" data-mp="rdr90k6itbra" />
                {SITE.phoneDisplay}
              </a>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}